// --------------------------------------------------------------------------
// enableSubmit.js
// --------------------------------------------------------------------------
// Enable the submit button when user selects a visit date
// --------------------------------------------------------------------------

RN.enableSubmit = function() {

  'use strict';

  var submitButton = byElement('enable-submit');

  function init() {
    byBehaviour('enable-submit').on('change', enableSubmit);
    byBehaviour('auto-submit').on('change', autoSubmit);
    byBehaviour('auto-submit').on('click', autoSubmit);
    byBehaviour('enable-ticket-type-submit').on('change', handleTicketTypes);

    byBehaviour('enable-ticket-type-submit').find('input').each(function(){
      if(this.value > 0) {
        submitButton.prop('disabled', false);
        byElement('ticket-types-visitors').removeClass('buy-tickets-ticket-types__people--is-disabled');
        return false;
      }
    });

  }

  function autoSubmit() {
    this.form.submit();
  }

  function enableSubmit() {
    submitButton.prop('disabled', false);
  }

  function handleTicketTypes() {
    var inputs = $(this).find('input');

    inputs.each(function(){
        if(this.value > 0){
            enableSubmit();
            return false;
        }
        else{
            submitButton.prop('disabled', true);
        }
    });

  }

  return {
    init: init
  };

}();